import { useParams } from 'react-router';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import { ClientStatus } from '../../../../model/ClientStatus';
import {
  fetchLegislativnyMaterialDetail,
} from '../../../../client/legislativnyMaterial/legislativnyMaterialDetailClient';
import LegislativnyMaterialDetail from '../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import PracovnyKrokEnum from '../../../../model/pracovnyKrok/PracovnyKrokEnum';

interface ReturnType {
  materialDetail: LegislativnyMaterialDetail;
  materialStatus: ClientStatus;
  reloadMaterialDetail
}

export default (pracovnyKrok?: PracovnyKrokEnum): ReturnType => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const {
    data: legMaterialDetail,
    status: legMaterialStatus,
    refetch: reloadMaterialDetail,
  } = useClientFetch(
    fetchLegislativnyMaterialDetail,
    [type, year, index, pracovnyKrok],
    [type, year, index],
  );
  return {
    materialDetail: legMaterialDetail,
    materialStatus: legMaterialStatus,
    reloadMaterialDetail,
  };
};
